// eslint-disable-next-line react/prop-types
export const SearchIcon = () => (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.25 14.75C11.5637 14.75 14.25 12.0637 14.25 8.75C14.25 5.43629 11.5637 2.75 8.25 2.75C4.93629 2.75 2.25 5.43629 2.25 8.75C2.25 12.0637 4.93629 14.75 8.25 14.75Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 16.25L12.4875 12.9875"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// eslint-disable-next-line react/prop-types
export const ExclamationCircleIcon = ({ size = '24', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke={props.stroke || 'currentColor'}
    width={size}
    height={size}
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
    />
  </svg>
);

// eslint-disable-next-line react/prop-types
export const QuestionMarkCircleIcon = ({ size = '24', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={props.stroke || 'currentColor'}
    {...props}
  >
    <g>
      <path
        d="M6.06065 6.00016C6.21739 5.55461 6.52675 5.1789 6.93395 4.93958C7.34116 4.70027 7.81991 4.61279 8.28544 4.69264C8.75096 4.77249 9.1732 5.01451 9.47737 5.37585C9.78154 5.73718 9.94802 6.19451 9.94732 6.66683C9.94732 8.00016 7.94732 8.66683 7.94732 8.66683M8.00065 11.3335H8.00732M14.6673 8.00016C14.6673 11.6821 11.6826 14.6668 8.00065 14.6668C4.31875 14.6668 1.33398 11.6821 1.33398 8.00016C1.33398 4.31826 4.31875 1.3335 8.00065 1.3335C11.6826 1.3335 14.6673 4.31826 14.6673 8.00016Z"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

// eslint-disable-next-line react/prop-types
export const ArchWindowIcon = ({ size = '24', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={props.stroke || 'currentColor'}
    {...props}
  >
    <path
      d="M8 1C4.134 1 1 4.272 1 8V18C1 18.2652 1.10536 18.5196 1.29289 18.7071C1.48043 18.8946 1.73478 19 2 19H14C14.2652 19 14.5196 18.8946 14.7071 18.7071C14.8946 18.5196 15 18.2652 15 18V8C15 4.272 11.866 1 8 1ZM8 1V19M1 11H15"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// eslint-disable-next-line react/prop-types
export const DollarIcon = ({ fill, size = '24', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.96424 0.416217C5.7085 0.149718 5.36166 0 5 0C4.63834 0 4.2915 0.149718 4.03576 0.416217C3.78003 0.682716 3.63636 1.04417 3.63636 1.42105V1.44C1.65636 1.95916 0 3.58674 0 5.84147C0 8.60211 2.48182 10.4211 5 10.4211C6.49818 10.4211 7.27273 11.4309 7.27273 12.1585C7.27273 12.8861 6.49818 13.8941 5 13.8941C3.50182 13.8941 2.72727 12.8861 2.72727 12.1585C2.72727 11.7816 2.5836 11.4202 2.32787 11.1537C2.07214 10.8872 1.7253 10.7375 1.36364 10.7375C1.00198 10.7375 0.655132 10.8872 0.399401 11.1537C0.143669 11.4202 0 11.7816 0 12.1585C0 14.4133 1.65636 16.0408 3.63636 16.56V16.5789C3.63636 16.9558 3.78003 17.3173 4.03576 17.5838C4.2915 17.8503 4.63834 18 5 18C5.36166 18 5.7085 17.8503 5.96424 17.5838C6.21997 17.3173 6.36364 16.9558 6.36364 16.5789V16.56C8.34364 16.0389 10 14.4133 10 12.1585C10 9.39789 7.51818 7.57895 5 7.57895C3.50182 7.57895 2.72727 6.56905 2.72727 5.84147C2.72727 5.1139 3.50182 4.10589 5 4.10589C6.49818 4.10589 7.27273 5.1139 7.27273 5.84147C7.27273 6.21836 7.4164 6.57981 7.67213 6.84631C7.92786 7.11281 8.2747 7.26253 8.63636 7.26253C8.99802 7.26253 9.34487 7.11281 9.6006 6.84631C9.85633 6.57981 10 6.21836 10 5.84147C10 3.58674 8.34364 1.95916 6.36364 1.44V1.42105C6.36364 1.04417 6.21997 0.682716 5.96424 0.416217Z"
      fill={fill || 'currentColor'}
    />
  </svg>
);

// eslint-disable-next-line react/prop-types
export const UpTriangleArrowIcon = ({ fill, size = '24', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 11 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M5.43359 0L10.6297 7.5L0.237442 7.5L5.43359 0Z" fill={fill || 'currentColor'} />
  </svg>
);

// eslint-disable-next-line react/prop-types
export const DownTriangleArrowIcon = ({ fill, size = '24', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 11 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.43359 8L0.23744 0.500001L10.6297 0.500001L5.43359 8Z"
      fill={fill || 'currentColor'}
    />
  </svg>
);

// eslint-disable-next-line react/prop-types
export const Dot = ({ fill, size = '24', alt = undefined, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {Boolean(alt) && <title>{alt}</title>}
    <circle cx="7" cy="7.5" r="7" fill={fill || 'currentColor'} />
  </svg>
);

// eslint-disable-next-line react/prop-types
export const NotFound = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="48" height="48" rx="24" fill="#F2F4F7" />
    <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9FAFB" strokeWidth="8" />
    <path
      d="M37 37L33.5001 33.5M36 27.5C36 32.1944 32.1944 36 27.5 36C22.8056 36 19 32.1944 19 27.5C19 22.8056 22.8056 19 27.5 19C32.1944 19 36 22.8056 36 27.5Z"
      stroke="#475467"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// eslint-disable-next-line react/prop-types
export const RightArrowIcon = ({ fill = '#07679B', ...props }) => (
  <svg
    width="7"
    height="13"
    viewBox="0 0 7 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.48742 0.702682L6.82267 6.07041C7.05813 6.30732 7.06009 6.68944 6.82267 6.92831L1.48742 12.296C1.2516 12.5333 0.871505 12.5355 0.634079 12.2967L0.206389 11.8664C-0.0290797 11.6295 -0.0275584 11.2439 0.207018 11.0079L4.26124 6.92895C4.49706 6.69169 4.49582 6.30578 4.26124 6.06978L0.207018 1.99087C-0.0287981 1.75362 -0.0310377 1.37121 0.206389 1.13234L0.634079 0.702049C0.869547 0.465147 1.25284 0.466677 1.48742 0.702682Z"
      fill={fill}
    />
  </svg>
);

// eslint-disable-next-line react/prop-types
export const UpArrowIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    {...props}
  >
    <path
      d="M5 11.0001L6.0575 12.0576L9.5 8.62262L12.9425 12.0576L14 11.0001L9.5 6.50012L5 11.0001Z"
      fill="black"
      fillOpacity="0.87"
    />
  </svg>
);

export const DollarSignIcon = () => (
  <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14.5" cy="14.5" r="14.5" fill="#97B068" />
    <path
      d="M19.3332 16.8195C19.3332 15.7604 19.0355 14.903 18.37 14.2978C17.8446 13.8271 17.1266 13.5244 15.9884 13.3563L15.3229 13.2555V10.3302C16.0409 10.3807 16.899 10.5992 17.4769 11.1372L19.018 9.67459C18.0723 8.80038 16.9866 8.3801 15.5681 8.29604V6.7998H13.7994V8.31285C11.5228 8.54821 10.1568 9.9772 10.1568 11.9105C10.1568 12.9192 10.4545 13.6757 11.05 14.2473C11.5753 14.7517 12.4159 15.1215 13.4666 15.256L14.027 15.3233V18.3662C12.9763 18.3326 11.9781 18.0636 11.2426 17.3575L9.6665 18.8705C10.8048 19.9801 12.1182 20.4004 13.7994 20.4508V22.2665H15.5681V20.3836C17.7571 20.1314 19.3332 18.8705 19.3332 16.8195ZM16.9515 16.8868C16.9515 17.7105 16.3736 18.2149 15.3229 18.3326V15.441C15.7782 15.5082 16.216 15.5586 16.5663 15.8781C16.8289 16.1134 16.9515 16.4665 16.9515 16.8868ZM14.027 13.1546C13.5367 13.0873 13.1514 12.936 12.8712 12.6839C12.6085 12.4485 12.5035 12.1291 12.5035 11.8265C12.5035 11.0868 13.0113 10.4815 14.027 10.3471V13.1546Z"
      fill="white"
    />
  </svg>
);

export const ThermostatIcon = ({ ...props }) => (
  <svg viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="31" cy="31" r="30" stroke="#00527C" strokeWidth="2" />
    <path
      d="M35.5112 25.9782C35.7221 34.5532 29.5251 35.7851 26.4904 33.3573C27.5481 32.0774 28.7316 31.1691 30.3518 30.5745C31.5153 30.1479 32.5675 29.9344 33.6497 28.68C32.0663 29.762 30.7925 29.8415 29.851 30.14C28.452 30.5834 27.3457 31.1795 26.1547 32.5906C26.0418 30.8159 26.6666 29.4204 27.4017 28.6086C28.1372 27.7976 29.1292 27.4106 30.6027 27.1426C32.0759 26.8746 34.1787 27.3575 35.5115 25.978L35.5112 25.9782Z"
      fill="#00527C"
    />
    <path
      d="M31 9.99992C25.4304 9.99992 20.0891 12.2125 16.1508 16.1507C12.2125 20.0892 10 25.4303 10 30.9999C10 36.5695 12.2126 41.9108 16.1508 45.8492C20.0893 49.7874 25.4304 51.9999 31 51.9999C36.5696 51.9999 41.9109 49.7873 45.8493 45.8492C49.7875 41.9107 52 36.5695 52 30.9999C51.9927 25.4325 49.7779 20.0955 45.8409 16.1588C41.9043 12.2219 36.567 10.0071 30.9998 9.99976L31 9.99992ZM48.5533 29.959L45.3578 30.2284L45.2801 29.3154L48.4756 29.0415L48.5533 29.959ZM48.0967 26.9824L45.0291 27.8043L44.796 26.8914L47.8913 26.1013L48.0967 26.9824ZM46.7729 23.271L47.1519 24.1018L44.2712 25.4303L43.8923 24.6088L46.7729 23.271ZM45.7001 21.381L43.0704 23.2069L42.55 22.4582L45.1798 20.6323L45.7001 21.381ZM43.728 18.8929L41.4454 21.1526L40.8473 20.4998L43.13 18.2401L43.728 18.8929ZM40.5964 16.2769L41.3495 16.7972L39.5236 19.427L38.7749 18.9066L40.5964 16.2769ZM37.8571 14.825L38.6879 15.204L37.3912 18.1076L36.5604 17.7286L37.8571 14.825ZM35.0175 13.8802L35.8987 14.113L35.1086 17.2038L34.1957 16.9707L35.0175 13.8802ZM32.041 13.4465L32.954 13.5242L32.6801 16.7198L31.7671 16.6421L32.041 13.4465ZM29.9593 13.4465L30.2287 16.6421L29.3158 16.7198L29.0419 13.5242L29.9593 13.4465ZM26.9828 13.8802L27.8044 16.9707L26.8914 17.2038L26.1013 14.1085L26.9828 13.8802ZM24.1021 14.8254L25.4307 17.7289L24.6088 18.1076L23.271 15.204L24.1021 14.8254ZM21.3628 16.2772L23.1888 18.9069L22.4401 19.4273L20.6142 16.7975L21.3628 16.2772ZM16.7976 20.6278L19.4273 22.4537L18.907 23.2024L16.2772 21.3765L16.7976 20.6278ZM15.2041 23.2709L18.1076 24.6087L17.7287 25.4395L14.8251 24.1109L15.2041 23.2709ZM14.1086 26.1013L17.2039 26.8913L16.9708 27.8043L13.8803 26.9824L14.1086 26.1013ZM13.5198 29.0459L16.7154 29.3198L16.6377 30.2328L13.4421 29.9634L13.5198 29.0459ZM13.4421 32.0406L16.6377 31.7712L16.7154 32.6841L13.5198 32.958L13.4421 32.0406ZM13.8758 35.0171L16.9708 34.1955L17.2039 35.1085L14.1086 35.8985L13.8758 35.0171ZM15.1996 38.7285L14.8206 37.8978L17.7242 36.5692L18.1076 37.3911L15.1996 38.7285ZM16.2724 40.6186L18.9021 38.7926L19.4225 39.5413L16.7927 41.3672L16.2724 40.6186ZM18.8884 43.7501L18.2448 43.1066L20.5046 40.8239L21.1526 41.5L18.8884 43.7501ZM20.4998 21.1522L18.2401 18.8925L18.8837 18.2489L21.1526 20.4994L20.4998 21.1522ZM30.9998 40.5863C27.5746 40.5863 24.4099 38.759 22.6976 35.7927C20.9853 32.8263 20.985 29.1719 22.6976 26.2057C24.4102 23.2395 27.5749 21.4121 30.9998 21.4121C33.0277 21.4016 35.0053 22.0417 36.6424 23.2384L39.5049 22.4349L38.7059 25.2882C39.9364 26.9372 40.5968 28.9417 40.5869 30.9992C40.5869 33.542 39.5768 35.9804 37.7789 37.7783C35.981 39.5762 33.5426 40.5863 30.9999 40.5863L30.9998 40.5863ZM43.1067 43.7501L40.8241 41.4674L41.4998 40.8465L43.7824 43.1291L43.1067 43.7501ZM45.202 41.3716L42.5723 39.5456L43.0926 38.797L45.7224 40.6229L45.202 41.3716ZM46.7952 38.7281L43.892 37.3904L44.2709 36.5596L47.1745 37.8881L46.7952 38.7281ZM47.891 35.8978L44.7957 35.1077L45.0288 34.1947L48.1193 35.0166L47.891 35.8978ZM48.4798 32.9531L45.2842 32.6792L45.3619 31.7663L48.5575 32.0357L48.4798 32.9531Z"
      fill="#00527C"
    />
  </svg>
);

export const HomeResiliencyIcon = ({ ...props }) => (
  <svg viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="31" cy="31" r="30" stroke="#00527C" strokeWidth="2" />
    <circle cx="30.4999" cy="31.5" r="19.5" fill="#00527C" />
    <path
      d="M23.3751 44.9903C23.1947 44.9367 23.0607 44.8344 23.0143 44.6493C22.9988 44.5908 22.9936 44.5421 23.0194 44.4885C23.2153 44.0452 23.406 43.6019 23.607 43.1586C24.9265 40.2017 26.2408 37.2399 27.5603 34.2829C27.6892 33.9955 27.8129 33.7081 27.9417 33.4207C27.952 33.3915 27.9727 33.3671 27.9675 33.3281C27.9263 33.3281 27.8799 33.3281 27.8387 33.3281C26.3955 33.3281 24.9523 33.3281 23.5091 33.3281C23.2411 33.3281 23.1019 33.2258 23.0143 32.9871C22.973 32.8751 23.0297 32.7825 23.0761 32.6949C23.4369 32.008 23.8029 31.3163 24.1688 30.6294C25.9831 27.1951 27.8026 23.7607 29.6169 20.3264C29.6993 20.1705 29.8076 20.0487 29.988 20C32.3899 20 34.7918 20 37.1936 20C37.1988 20.0049 37.204 20.0146 37.2091 20.0146C37.5132 20.0682 37.6369 20.4189 37.4565 20.6917C35.7659 23.2054 34.0805 25.719 32.395 28.2327C32.3796 28.257 32.3641 28.2862 32.3435 28.3203C32.3899 28.3398 32.4363 28.335 32.4775 28.335C34.1526 28.335 35.8278 28.335 37.5029 28.335C37.74 28.335 37.9049 28.4324 37.9719 28.6126C38.0286 28.7636 37.9977 28.9 37.8946 29.0218C37.1112 29.9035 36.3277 30.7853 35.5391 31.667C34.6938 32.6169 33.8485 33.5668 32.9981 34.5168C32.2352 35.3741 31.4724 36.2315 30.7044 37.0889C29.9416 37.9462 29.1788 38.8036 28.4159 39.661C27.6892 40.4793 26.9573 41.2929 26.2305 42.1113C25.4316 43.0076 24.6327 43.9039 23.8338 44.8051C23.7513 44.8977 23.6534 44.961 23.5348 45C23.4781 44.9903 23.4266 44.9903 23.3751 44.9903Z"
      fill="white"
    />
    <line x1="14.9878" y1="17.8711" x2="46.9878" y2="45.8711" stroke="white" strokeWidth="3" />
  </svg>
);

export const SolarPowerIcon = ({ ...props }) => (
  <svg viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="31" cy="31" r="30" stroke="#00527C" strokeWidth="2" />
    <path
      d="M25.8398 46.9206H36.2823C36.4484 46.9206 36.6059 46.848 36.7141 46.7222C36.8219 46.5962 36.8695 46.4295 36.8443 46.2655L35.959 40.5335C35.9164 40.2563 35.6777 40.0518 35.3973 40.0518H26.7252C26.4445 40.0518 26.2062 40.2563 26.1633 40.5335L25.2783 46.2655C25.253 46.4295 25.3006 46.5962 25.4085 46.7222C25.5167 46.848 25.6742 46.9206 25.84 46.9206H25.8398Z"
      fill="#00527C"
    />
    <path
      d="M34.0763 31.498H28.046C27.7656 31.498 27.5269 31.7026 27.484 31.9798L26.599 37.7118C26.5738 37.8758 26.6214 38.0424 26.7293 38.1685C26.8374 38.2946 26.9949 38.3669 27.1607 38.3669H34.9615C35.1276 38.3669 35.2851 38.2946 35.393 38.1685C35.5012 38.0424 35.5488 37.8758 35.5235 37.7118L34.6385 31.9798H34.6382C34.5956 31.7026 34.357 31.498 34.0766 31.498H34.0763Z"
      fill="#00527C"
    />
    <path
      d="M38.5755 46.4392C38.6181 46.7163 38.8568 46.9209 39.1372 46.9209H49.4518C49.6457 46.9209 49.8265 46.8218 49.9308 46.6584C50.0352 46.495 50.049 46.2896 49.9676 46.1135L47.3124 40.3815C47.2196 40.1807 47.0182 40.052 46.7966 40.052H38.2524C38.0864 40.052 37.9288 40.1246 37.821 40.2504C37.7128 40.3765 37.6652 40.5434 37.6905 40.7074L38.5755 46.4392Z"
      fill="#00527C"
    />
    <path
      d="M37.8165 38.3667H45.4894C45.6834 38.3667 45.8641 38.2679 45.9685 38.1042C46.0731 37.9408 46.0869 37.7354 46.0052 37.5593L43.3501 31.8273C43.2572 31.6265 43.0559 31.4978 42.8343 31.4978H36.9315C36.7654 31.4978 36.6079 31.5704 36.5 31.6965C36.3919 31.8223 36.3443 31.9892 36.3696 32.1532L37.2545 37.8853L37.2548 37.885C37.2974 38.1621 37.5361 38.3667 37.8165 38.3667L37.8165 38.3667Z"
      fill="#00527C"
    />
    <path
      d="M16.632 38.3667H24.3049C24.5856 38.3667 24.8239 38.1621 24.8669 37.885L25.7518 32.1529V32.1532C25.7771 31.9892 25.7295 31.8223 25.6216 31.6962C25.5138 31.5704 25.3559 31.4978 25.1902 31.4978H19.2871C19.0658 31.4978 18.8645 31.6265 18.7713 31.8273L16.1162 37.5593C16.0348 37.7354 16.0486 37.9408 16.1529 38.1042C16.2572 38.2679 16.438 38.3667 16.632 38.3667L16.632 38.3667Z"
      fill="#00527C"
    />
    <path
      d="M12.6699 46.9206H22.9845C23.2651 46.9206 23.5035 46.7161 23.5464 46.4389L24.4314 40.7069C24.4567 40.5432 24.409 40.3762 24.3012 40.2501C24.193 40.1244 24.0355 40.0518 23.8697 40.0518H15.3248C15.1035 40.0518 14.9021 40.1805 14.809 40.3812L12.1538 46.1133C12.0721 46.2893 12.0862 46.4948 12.1906 46.6582C12.2949 46.8216 12.4757 46.9206 12.6696 46.9206L12.6699 46.9206Z"
      fill="#00527C"
    />
    <path
      d="M36.4591 20.5732C37.1627 23.5546 35.3167 26.5415 32.3353 27.2455C29.3542 27.9491 26.367 26.103 25.6633 23.1217C24.9594 20.1406 26.8058 17.1534 29.7868 16.4497C32.7682 15.7458 35.7551 17.5922 36.4591 20.5732Z"
      fill="#00527C"
    />
    <path d="M30.218 9H31.9032V13.5717H30.218V9Z" fill="#00527C" />
    <path
      d="M36.3169 15.4L39.5493 12.1676L40.7408 13.3591L37.5084 16.5915L36.3169 15.4Z"
      fill="#00527C"
    />
    <path d="M39.337 21.0045H43.9087V22.6897H39.337V21.0045Z" fill="#00527C" />
    <path d="M18.2128 21.0045H22.7845V22.6897H18.2128V21.0045Z" fill="#00527C" />
    <path
      d="M21.3803 13.3591L22.5718 12.1676L25.8042 15.4L24.6127 16.5915L21.3803 13.3591Z"
      fill="#00527C"
    />
  </svg>
);

export const EvChargerIcon = ({ ...props }) => (
  <svg viewBox="0 0 63 62" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="31.5" cy="31" r="30" stroke="#00527C" strokeWidth="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.6153 8.80735L32.9554 9.89558L32.6445 9.13582C32.5872 8.99533 32.4273 8.92896 32.2871 8.98597C31.3532 9.36798 28.0779 10.7081 27.9484 10.7613C26.3852 11.4001 26.0524 12.7472 26.6315 14.5963C26.3732 14.7912 26.0347 15.0194 25.6191 15.2983L25.5914 15.3169C25.1185 15.6344 24.5669 16.0045 23.9885 16.429C22.8099 17.2938 21.4917 18.4034 20.4153 19.8281C19.3342 21.2589 18.494 23.0117 18.2843 25.149C18.1813 26.199 18.2318 27.3284 18.4715 28.5436H16.8337C16.3476 28.5436 15.8812 28.7363 15.5373 29.0791C15.1933 29.4222 15.0001 29.8876 15.0001 30.3731L14.9999 30.373C14.9999 30.8616 15.1942 31.3304 15.5401 31.6767C15.8856 32.0225 16.3551 32.2176 16.8447 32.2192H17.1825C16.878 32.4347 16.6121 32.6448 16.3849 32.8272C15.8223 33.2872 15.4969 33.9754 15.4984 34.7011V45.1975C15.5015 45.9501 16.1125 46.5597 16.8668 46.5628H19.8307C20.5866 46.5628 21.1991 45.9517 21.1991 45.1975V43.6444H39.9021V45.1698C39.9021 45.9239 40.5145 46.5351 41.27 46.5351H44.234C44.9887 46.532 45.5992 45.9228 45.6023 45.1698V34.6846C45.6042 33.959 45.2785 33.2707 44.7158 32.8107H44.7162C44.6242 32.7418 44.5312 32.6688 44.4348 32.5931C44.2761 32.4687 44.108 32.3367 43.9186 32.2027H44.2564C44.8905 32.168 45.462 31.8101 45.7692 31.2557C46.0769 30.7013 46.0769 30.028 45.7692 29.4736C45.4621 28.9191 44.8905 28.5617 44.2564 28.527H41.9904C41.8435 28.527 41.7025 28.5852 41.5985 28.6889C41.495 28.7922 41.4366 28.933 41.4366 29.0795L41.4362 29.986C41.3253 29.6212 41.1816 29.2013 41.0208 28.7645C40.3337 26.9515 39.5581 25.7355 38.7107 25.1386C38.6423 25.0881 38.5623 25.0557 38.4781 25.0445C35.9481 24.7018 33.4019 24.4932 30.8495 24.4199H30.2405C27.6944 24.4808 25.1535 24.6763 22.6286 25.006C22.5444 25.0171 22.4644 25.0495 22.396 25.0997L22.3956 25.1C21.5481 25.6968 20.7726 26.913 20.0855 28.7259C20.0641 28.784 20.043 28.8418 20.0223 28.8992C19.6855 27.5567 19.6084 26.3588 19.7133 25.2892C19.8925 23.4628 20.6078 21.9551 21.5609 20.6937C22.5186 19.4262 23.7131 18.4119 24.8379 17.5866C25.3919 17.1802 25.9221 16.8243 26.3987 16.5044L26.3988 16.5043L26.421 16.4894L26.421 16.4894C26.6909 16.3082 26.9505 16.134 27.1846 15.9689C28.0718 17.7477 29.2658 18.5047 30.8507 17.8552C30.9812 17.8026 34.2559 16.4627 35.1895 16.0799C35.3297 16.0229 35.3968 15.8629 35.3392 15.7229L35.0287 14.9633L37.6885 13.875C38.1948 13.6671 37.7805 12.6534 37.2739 12.8606C37.2133 12.8859 35.3979 13.6287 34.6135 13.9493L33.9921 12.4297L33.37 10.9094C34.1548 10.5883 35.9709 9.84482 36.03 9.82051C36.5366 9.61335 36.122 8.60002 35.6153 8.80735ZM20.6542 30.8319C20.6274 30.7647 20.6011 30.6978 20.5755 30.6312C21.0012 29.1782 21.842 26.9227 22.8998 26.0782C25.4348 25.7297 27.9872 25.523 30.5449 25.459C33.1027 25.523 35.6551 25.7297 38.19 26.0782H38.1902C39.3036 26.9403 40.168 29.3946 40.5722 30.8319H20.6542ZM17.687 35.3867C17.8667 36.0456 18.2141 36.6474 18.6951 37.1333C18.7844 37.2231 18.9019 37.2794 19.0275 37.2937C19.0394 37.2937 19.0867 37.2976 19.1656 37.3042C19.5624 37.3374 20.7583 37.4375 22.2738 37.4375C22.7781 37.4375 23.3152 37.4375 23.8694 37.4043V37.4039C24.3192 37.3866 24.7029 37.0735 24.8096 36.6374C24.9162 36.2009 24.7203 35.7471 24.3293 35.5247C22.7523 34.5804 21.0059 33.9515 19.1881 33.6728C18.7341 33.6145 18.2808 33.7869 17.9806 34.1316C17.6803 34.4755 17.5706 34.9455 17.6869 35.3866L17.687 35.3867ZM36.2841 36.6359C36.3869 37.0619 36.7544 37.3727 37.1926 37.4039C37.4785 37.4039 37.7643 37.4128 38.041 37.4213C38.3006 37.4293 38.5521 37.4371 38.7882 37.4371C40.6052 37.4371 41.9628 37.3044 42.0346 37.2933V37.2937C42.1605 37.2794 42.2776 37.2231 42.3669 37.1333C42.8484 36.6474 43.1954 36.0455 43.3751 35.3867C43.4918 34.9456 43.3816 34.4755 43.0814 34.1316C42.7811 33.7869 42.3278 33.6145 41.8738 33.6728C40.056 33.9515 38.3098 34.5804 36.7327 35.5247C36.3559 35.7572 36.1743 36.2072 36.284 36.6359L36.2841 36.6359ZM30.7888 42.5721H39.0986V41.8148C39.097 41.2129 38.8567 40.6358 38.4301 40.21C38.0034 39.7843 37.425 39.5445 36.8217 39.543H24.2907C23.6871 39.5446 23.109 39.7844 22.682 40.21C22.2554 40.6357 22.015 41.2129 22.0138 41.8148V42.5721H30.7888Z"
      fill="#00527C"
    />
  </svg>
);

export const ApplyForAssistanceIcon = ({ ...props }) => (
  <svg viewBox="0 0 63 62" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="31.5" cy="31" r="30" stroke="#00527C" strokeWidth="2" />
    <circle cx="31.5" cy="31" r="21" fill="#00527C" />
    <path
      d="M38.4997 34.3591C38.4997 32.8252 38.0686 31.5834 37.1048 30.7069C36.3439 30.0252 35.3041 29.5869 33.6555 29.3434L32.6918 29.1973V24.9608C33.7316 25.0339 34.9744 25.3504 35.8113 26.1295L38.0432 24.0113C36.6737 22.7452 35.1012 22.1365 33.0468 22.0147V19.8478H30.4852V22.0391C27.1881 22.38 25.2099 24.4495 25.2099 27.2495C25.2099 28.7104 25.641 29.806 26.5034 30.6339C27.2642 31.3643 28.4816 31.9 30.0034 32.0947L30.815 32.1921V36.5991C29.2932 36.5504 27.8476 36.1608 26.7823 35.1382L24.4997 37.3295C26.1483 38.9365 28.0505 39.5452 30.4852 39.6182V42.2478H33.0468V39.5208C36.2171 39.1556 38.4997 37.3295 38.4997 34.3591ZM35.0505 34.4565C35.0505 35.6495 34.2135 36.38 32.6918 36.5504V32.3626C33.3512 32.46 33.9852 32.533 34.4925 32.9956C34.8729 33.3365 35.0505 33.8478 35.0505 34.4565ZM30.815 29.0513C30.1048 28.9539 29.5468 28.7347 29.141 28.3695C28.7606 28.0286 28.6084 27.566 28.6084 27.1278C28.6084 26.0565 29.3439 25.18 30.815 24.9852V29.0513Z"
      fill="white"
    />
  </svg>
);

export const HomeElectrificationIcon = ({ ...props }) => (
  <svg viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="31" cy="31" r="30" stroke="#00527C" strokeWidth="2" />
    <path
      d="M44.4231 29.8857L32.2361 19.9044C31.4012 19.1754 30.156 19.1754 29.3208 19.9044L17.1397 29.8806C16.5546 30.3914 16.2191 31.1298 16.2191 31.9064V45.8409C16.2191 46.4783 16.7407 46.9999 17.3781 46.9999H44.1786C44.816 46.9999 45.3376 46.4783 45.3376 45.8409L45.3378 31.8991C45.3378 31.1271 45.0041 30.3929 44.4228 29.8856L44.4231 29.8857ZM36.1421 35.375L27.0969 44.1528L30.3373 37.8492L26.4202 38.6009C25.5512 38.7677 24.8375 37.9143 25.1554 37.0882L27.6729 29.9707C27.9577 29.2315 28.6309 28.7125 29.4183 28.6256L32.3182 28.3055C33.1548 28.2133 33.7077 29.1526 33.2208 29.8393L30.7788 34.2046L35.2315 33.5257C36.2755 33.3666 36.9053 34.6448 36.1424 35.3753L36.1421 35.375Z"
      fill="#00527C"
    />
    <path
      d="M48.9723 26.5602L31.8041 12.3517C31.5056 12.1047 31.14 11.9909 30.7792 12.0006C30.4181 11.9909 30.0525 12.1047 29.7543 12.3517L23.4492 17.5698C23.1566 17.812 22.7141 17.604 22.7141 17.2241V14.625C22.7141 13.9876 22.1926 13.466 21.5552 13.466L18.4646 13.4657C17.8272 13.4657 17.3057 13.9873 17.3057 14.6247V22.1511C17.3057 22.4698 17.1637 22.7717 16.9181 22.9749L12.5858 26.5605C11.9783 27.0633 11.8109 27.9469 12.2378 28.6099C12.7463 29.4001 13.8225 29.5489 14.525 28.9676L29.5144 16.562C30.2482 15.9545 31.3104 15.9545 32.0443 16.562L47.0336 28.9676C47.7362 29.5492 48.8124 29.4001 49.3208 28.6099C49.7474 27.9469 49.5801 27.0634 48.9726 26.5605L48.9723 26.5602Z"
      fill="#00527C"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.2539 6L6.34619 18"
      stroke="#042037"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.34619 6L18.2539 18"
      stroke="#042037"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseIconHighContrast = () => (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24.4748 10.73L11.1183 24.19" stroke="#042037" strokeWidth="1.8" />
    <path d="M11.1183 10.73L24.4748 24.19" stroke="#042037" strokeWidth="1.8" />
    <path d="M23.7539 11.47L11.8462 23.47" stroke="white" />
    <path d="M11.8462 11.47L23.7539 23.47" stroke="white" />
  </svg>
);

export const CircleCloseIcon = ({ color = '#000' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 330 330" fill={color}>
    <g>
      <path
        d="M165,0C120.926,0,79.492,17.163,48.328,48.327c-64.334,64.333-64.334,169.011-0.002,233.345
		C79.49,312.837,120.926,330,165,330c44.072,0,85.508-17.163,116.672-48.328c64.334-64.334,64.334-169.012,0-233.345
		C250.508,17.163,209.072,0,165,0z M239.246,239.245c-2.93,2.929-6.768,4.394-10.607,4.394c-3.838,0-7.678-1.465-10.605-4.394
		L165,186.213l-53.033,53.033c-2.93,2.929-6.768,4.394-10.607,4.394c-3.838,0-7.678-1.465-10.605-4.394
		c-5.859-5.857-5.859-15.355,0-21.213L143.787,165l-53.033-53.033c-5.859-5.857-5.859-15.355,0-21.213
		c5.857-5.857,15.355-5.857,21.213,0L165,143.787l53.031-53.033c5.857-5.857,15.355-5.857,21.213,0
		c5.859,5.857,5.859,15.355,0,21.213L186.213,165l53.033,53.032C245.104,223.89,245.104,233.388,239.246,239.245z"
      />
    </g>
  </svg>
);

export const MenuCloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 6L6 18"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6L18 18"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StarIconHalfFilled = () => (
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5 5.43L10.1075 4.965L8 0L5.8925 4.9725L0.5 5.43L4.595 8.9775L3.365 14.25L8 11.4525L12.635 14.25L11.4125 8.9775L15.5 5.43ZM8 10.05V3.075L9.2825 6.105L12.5675 6.39L10.0775 8.55L10.8275 11.76L8 10.05Z"
      fill="#FFB400"
    />
  </svg>
);

export const StarIconFilled = ({ ...props }) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.8225 8L9 2L7.1775 8H1.5L6.135 11.3075L4.3725 17L9 13.4825L13.635 17L11.8725 11.3075L16.5 8H10.8225Z"
      fill="#FFB400"
    />
  </svg>
);

export const StarIconEmpty = () => (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 7.43L11.1075 6.965L9 2L6.8925 6.9725L1.5 7.43L5.595 10.9775L4.365 16.25L9 13.4525L13.635 16.25L12.4125 10.9775L16.5 7.43ZM9 12.05L6.18 13.7525L6.93 10.5425L4.44 8.3825L7.725 8.0975L9 5.075L10.2825 8.105L13.5675 8.39L11.0775 10.55L11.8275 13.76L9 12.05Z"
      fill="#B0B0B0"
    />
  </svg>
);

export const ExternalLinkIcon = () => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 10.25V14.75C14 15.1478 13.842 15.5294 13.5607 15.8107C13.2794 16.092 12.8978 16.25 12.5 16.25H4.25C3.85218 16.25 3.47064 16.092 3.18934 15.8107C2.90804 15.5294 2.75 15.1478 2.75 14.75V6.5C2.75 6.10218 2.90804 5.72064 3.18934 5.43934C3.47064 5.15804 3.85218 5 4.25 5H8.75"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11.75 2.75H16.25V7.25" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 11L16.25 2.75" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const HamburgerIcon = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 12.5H21"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 6.5H21"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 18.5H21"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIcon = ({ fill = '#FFF' }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.25 5.25V0.75C5.25 0.335786 5.58579 0 6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25L11.25 5.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75L6.75 6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25Z"
      fill={fill}
    />
  </svg>
);

export const MinusIcon = ({ fill = '#FFF' }) => (
  <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.25 0V0.0309136C5.25 0 5 -7.45058e-09 6.75 0.0118537C7.16421 0.0118537 6.75 0.0118537 6.75 0.0384777V0.0118537L11.25 0C11.6642 0 12 0.335789 12 0.749999C12 1.16421 11.6642 1.5 11.25 1.5H6.75C6.75 1.5 6.75 1.5 5.25 1.5H0.75C0.335786 1.5 0 1.16421 0 0.749999C0 0.335789 0.335786 0 0.75 0H5.25Z"
      fill={fill}
    />
  </svg>
);

export const NextButtonIcon = ({ disabled }) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="28" rx="14" fill={disabled ? '#F8F8F8' : '#F1F1F1'} />
    <path
      d="M12.3352 9L11.1602 10.175L14.9768 14L11.1602 17.825L12.3352 19L17.3352 14L12.3352 9Z"
      fill={disabled ? '#777' : '#000'}
      fillOpacity="0.87"
    />
  </svg>
);

export const PreviousButtonIcon = ({ disabled }) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="28"
      y="28"
      width="28"
      height="28"
      rx="14"
      transform="rotate(-180 28 28)"
      fill={disabled ? '#F8F8F8' : '#F1F1F1'}
    />
    <path
      d="M15.6648 19L16.8398 17.825L13.0232 14L16.8398 10.175L15.6648 9L10.6648 14L15.6648 19Z"
      fill={disabled ? '#777' : '#000'}
      fillOpacity="0.87"
    />
  </svg>
);

export const PriceTagIcon = ({ ...props }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="rebate eligible tag"
    role="img"
    focusable="false"
    {...props}
  >
    <path
      d="M14.1679 9.58208L9.08917 14.6608C8.9576 14.7925 8.80135 14.897 8.62937 14.9683C8.45739 15.0396 8.27305 15.0763 8.08687 15.0763C7.9007 15.0763 7.71636 15.0396 7.54438 14.9683C7.3724 14.897 7.21615 14.7925 7.08458 14.6608L1 8.58333V1.5H8.08333L14.1679 7.58458C14.4318 7.85001 14.5799 8.20907 14.5799 8.58333C14.5799 8.9576 14.4318 9.31665 14.1679 9.58208Z"
      fill="#FFB400"
    />
    <path
      d="M4.54167 5.04167H4.54875M14.1679 9.58208L9.08917 14.6608C8.9576 14.7925 8.80135 14.897 8.62937 14.9683C8.45739 15.0396 8.27305 15.0763 8.08687 15.0763C7.9007 15.0763 7.71636 15.0396 7.54438 14.9683C7.3724 14.897 7.21615 14.7925 7.08458 14.6608L1 8.58333V1.5H8.08333L14.1679 7.58458C14.4318 7.85001 14.5799 8.20907 14.5799 8.58333C14.5799 8.9576 14.4318 9.31665 14.1679 9.58208Z"
      stroke="#FFB400"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="4" cy="4.5" r="1" fill="white" />
  </svg>
);

export const RebateIcon = ({ ...props }) => (
  <svg viewBox="0 0 63 62" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="31.5" cy="31" r="30" stroke="#00527C" strokeWidth="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 18C18.4477 18 18 18.4477 18 19V33.087C18 33.3587 18.1105 33.6187 18.3062 33.8072L30.8512 45.8932C31.2169 46.2463 31.6491 46.5245 32.1224 46.7138C32.5957 46.903 33.1019 47 33.6123 47C34.1226 47 34.6288 46.903 35.1021 46.7138C35.5754 46.5245 36.0078 46.2462 36.3735 45.8931L46.8448 35.7931L46.847 35.791C47.5811 35.0787 48 34.1074 48 33.087C48 32.0667 47.5811 31.0954 46.847 30.3831L34.2992 18.2802C34.1128 18.1005 33.8639 18 33.6049 18H19Z"
      fill="#00527C"
    />
  </svg>
);

export const MoneyLightbulbIcon = ({ ...props }) => (
  <svg
    width="62"
    height="62"
    viewBox="0 0 62 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="31" cy="31" r="30" stroke="#00527C" strokeWidth="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.6048 46.0105L32.6284 48.1374C32.6284 48.1374 32.351 49.1547 31.9811 49.1547H29.8542C29.4843 49.1547 29.2069 48.1374 29.2069 48.1374L25.2305 46.0105L24.9531 42.0342H36.9747L36.6048 46.0105Z"
      fill="#00527C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.9619 13.0898C23.8415 13.0898 18.0156 19.0082 18.0156 26.2211C18.0156 30.5674 20.1425 34.4513 23.3791 36.8556C24.1189 37.4104 24.6737 38.3352 24.6737 39.3524H37.3426C37.3426 38.3352 37.805 37.4104 38.6373 36.8556C41.8738 34.4513 44.0007 30.5674 44.0007 26.2211C43.9083 18.9157 38.0824 13.0898 30.9619 13.0898Z"
      fill="#00527C"
    />
    <path
      d="M37 28.7174C37 27.6902 36.6304 26.8587 35.8043 26.2717C35.1522 25.8152 34.2609 25.5217 32.8478 25.3587L32.0217 25.2609V22.4239C32.913 22.4728 33.9783 22.6848 34.6957 23.2065L36.6087 21.788C35.4348 20.9402 34.087 20.5326 32.3261 20.4511V19H30.1304V20.4674C27.3043 20.6957 25.6087 22.0815 25.6087 23.9565C25.6087 24.9348 25.9783 25.6685 26.7174 26.2228C27.3696 26.712 28.413 27.0707 29.7174 27.2011L30.413 27.2663V30.2174C29.1087 30.1848 27.8696 29.9239 26.9565 29.2391L25 30.7065C26.413 31.7826 28.0435 32.1902 30.1304 32.2391V34H32.3261V32.1739C35.0435 31.9293 37 30.7065 37 28.7174ZM34.0435 28.7826C34.0435 29.5815 33.3261 30.0707 32.0217 30.1848V27.3804C32.587 27.4457 33.1304 27.4946 33.5652 27.8043C33.8913 28.0326 34.0435 28.375 34.0435 28.7826ZM30.413 25.163C29.8043 25.0978 29.3261 24.9511 28.9783 24.7065C28.6522 24.4783 28.5217 24.1685 28.5217 23.875C28.5217 23.1576 29.1522 22.5707 30.413 22.4402V25.163Z"
      fill="white"
    />
  </svg>
);

export const LeafIcon = ({ ...props }) => (
  <svg
    width="62"
    height="62"
    viewBox="0 0 62 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="31" cy="31" r="30" stroke="#00527C" strokeWidth="2" />
    <path
      d="M44.9838 17.0006C45.6361 43.297 26.4667 47.075 17.0794 39.6297C20.3513 35.7048 24.0124 32.9192 29.0242 31.0958C32.6233 29.7876 35.8778 29.1329 39.2255 25.286C34.3276 28.604 30.3874 28.8478 27.4748 29.7635C23.1475 31.1232 19.7253 32.9511 16.041 37.2786C15.6919 31.8362 17.6246 27.5565 19.8985 25.0671C22.1735 22.58 25.2422 21.3931 29.8003 20.5712C34.3573 19.7494 40.8619 21.2305 44.9846 17L44.9838 17.0006Z"
      fill="#00527C"
    />
  </svg>
);

export const FilterIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" fill="#031A2D" />
  </svg>
);

export const UpArrowsIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6344 12.695C14.4002 12.8823 14.0826 12.9875 13.7515 12.9875C13.4204 12.9875 13.1028 12.8823 12.8687 12.695L7.50781 8.40598L2.14695 12.695C2.03176 12.7904 1.89397 12.8665 1.74162 12.9189C1.58926 12.9713 1.4254 12.9988 1.2596 13C1.09379 13.0011 0.929357 12.9758 0.77589 12.9256C0.622424 12.8754 0.482999 12.8012 0.365751 12.7074C0.248504 12.6136 0.155779 12.502 0.0929908 12.3792C0.0302028 12.2565 -0.00139149 12.1249 4.85493e-05 11.9922C0.00148954 11.8596 0.0359391 11.7285 0.101384 11.6066C0.16683 11.4847 0.26196 11.3745 0.381228 11.2823L6.62495 6.28695C6.85912 6.09965 7.17668 5.99443 7.50781 5.99443C7.83893 5.99443 8.15649 6.09965 8.39067 6.28695L14.6344 11.2823C14.8685 11.4697 15 11.7237 15 11.9887C15 12.2536 14.8685 12.5076 14.6344 12.695ZM14.6344 6.70056C14.4002 6.88786 14.0826 6.99308 13.7515 6.99308C13.4204 6.99308 13.1028 6.88786 12.8687 6.70056L7.50781 2.41155L2.14695 6.70056C1.91144 6.88255 1.596 6.98325 1.26858 6.98098C0.941168 6.9787 0.627967 6.87363 0.39644 6.68839C0.164913 6.50316 0.0335831 6.25258 0.0307373 5.99062C0.0278924 5.72867 0.153758 5.4763 0.381228 5.28788L6.62494 0.292514C6.85912 0.105217 7.17668 -2.69738e-07 7.50781 -2.98686e-07C7.83893 -3.27634e-07 8.15649 0.105217 8.39067 0.292513L14.6344 5.28787C14.8685 5.47523 15 5.7293 15 5.99422C15 6.25914 14.8685 6.51321 14.6344 6.70056Z"
      fill="#AD7A11"
    />
  </svg>
);

export const ClockIcon = ({ ...props }) => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.125 3.75738C20.8218 4.73709 22.2333 6.14297 23.2198 7.83584C24.2063 9.52871 24.7335 11.4499 24.7494 13.4091C24.7652 15.3684 24.269 17.2978 23.31 19.0064C22.351 20.715 20.9624 22.1435 19.2816 23.1505C17.6009 24.1575 15.6863 24.7081 13.7274 24.7477C11.7684 24.7873 9.83312 24.3147 8.113 23.3765C6.39288 22.4384 4.9476 21.0672 3.92025 19.3988C2.89289 17.7305 2.31909 15.8227 2.25563 13.8644L2.25 13.4999L2.25563 13.1354C2.31863 11.1925 2.88399 9.29909 3.89659 7.63975C4.9092 5.98041 6.33449 4.61176 8.0335 3.66725C9.73252 2.72273 11.6473 2.23458 13.5911 2.25037C15.535 2.26617 17.4416 2.78538 19.125 3.75738ZM13.5 6.74988C13.2244 6.74992 12.9585 6.85108 12.7526 7.03418C12.5467 7.21729 12.4151 7.4696 12.3829 7.74325L12.375 7.87488V13.4999L12.3851 13.6473C12.4108 13.8424 12.4872 14.0275 12.6067 14.1839L12.7046 14.2964L16.0796 17.6714L16.1854 17.7636C16.3827 17.9167 16.6253 17.9998 16.875 17.9998C17.1247 17.9998 17.3673 17.9167 17.5646 17.7636L17.6704 17.6703L17.7637 17.5645C17.9168 17.3672 17.9999 17.1246 17.9999 16.8749C17.9999 16.6252 17.9168 16.3825 17.7637 16.1853L17.6704 16.0795L14.625 13.033V7.87488L14.6171 7.74325C14.5849 7.4696 14.4533 7.21729 14.2474 7.03418C14.0415 6.85108 13.7755 6.74992 13.5 6.74988Z"
      fill="#07679B"
    />
  </svg>
);

export const RemoveIcon = ({ color = 'currentColor', size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10.5664" cy="10" r="9" stroke={color} strokeWidth="2" />
    <path d="M4.41016 10H16.3332" stroke={color} strokeWidth="2" />
  </svg>
);

export const LockIcon = () => (
  <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.6875 6.97222V4.63889C9.6875 2.49112 8.14848 0.75 6.25 0.75C4.35152 0.75 2.8125 2.49112 2.8125 4.63889V6.97222M4.05 14.75H8.45C9.60511 14.75 10.1827 14.75 10.6239 14.4957C11.0119 14.272 11.3275 13.915 11.5252 13.476C11.75 12.9769 11.75 12.3235 11.75 11.0167V10.7056C11.75 9.39877 11.75 8.74537 11.5252 8.24624C11.3275 7.8072 11.0119 7.45025 10.6239 7.22654C10.1827 6.97222 9.60511 6.97222 8.45 6.97222H4.05C2.89489 6.97222 2.31734 6.97222 1.87614 7.22654C1.48806 7.45025 1.17254 7.8072 0.974799 8.24624C0.75 8.74537 0.75 9.39877 0.75 10.7056V11.0167C0.75 12.3235 0.75 12.9769 0.974799 13.476C1.17254 13.915 1.48806 14.272 1.87614 14.4957C2.31734 14.75 2.89489 14.75 4.05 14.75Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
